// extracted by mini-css-extract-plugin
export default {"skipped":"_05f5113590f24f6a","navTab":"dc816a4562c4d1fd","active":"b7c110603a752874","childrenWrapper":"f220d223ec3aa89a","icon":"_1b5d28d62a97bd36"};